import { render, staticRenderFns } from "./UPEIPsych1020A2Task2.vue?vue&type=template&id=5bc67f0b&scoped=true&"
import script from "./UPEIPsych1020A2Task2.vue?vue&type=script&lang=ts&"
export * from "./UPEIPsych1020A2Task2.vue?vue&type=script&lang=ts&"
import style0 from "./UPEIPsych1020A2Task2.vue?vue&type=style&index=0&id=5bc67f0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc67f0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VForm,VRow})
